export default {
	inserted: function(el, binding, vnode) {
		populateRegion(el, binding);
	},
	update: function(el, binding, vnode) {
		populateRegion(el, binding);
	}
}

function populateRegion(el, binding) {
	var origImageWidth = binding.value.origImageWidth;
    var origImageHeight = binding.value.origImageHeight;
    var annotation = binding.value.annotation;
    
    const imgResultDiv = el.parentElement;
    const imgElement = Array.from(imgResultDiv.children).find(
		el => el.nodeName === "IMG"
    );
    const annotationDiv = Array.from(imgResultDiv.children).find(
		el => el.id === "annotation" + annotation.id
    );
    
    var boxX = 0, boxY = 0, boxW = 0, boxH = 0, positionY;
    
    if (imgElement.clientWidth < imgResultDiv.clientWidth) {
		boxX = (annotation.box_x  / origImageWidth * imgElement.clientWidth / imgResultDiv.clientWidth) * 100;
		boxW = (annotation.box_w / origImageWidth * imgElement.clientWidth / imgResultDiv.clientWidth) * 100;
	} else {
		boxX = annotation.box_x / origImageWidth * 100;
		boxW = annotation.box_w / origImageWidth * 100;
	}
    
	if (imgElement.clientHeight < imgResultDiv.clientHeight) {
		boxY = ((1 - (annotation.box_y + annotation.box_h) / origImageHeight) * imgElement.clientHeight / imgResultDiv.clientHeight) * 100;
		boxH = (annotation.box_h / origImageHeight * imgElement.clientHeight / imgResultDiv.clientHeight) * 100;
		positionY = 'bottom'; // Using 'bottom' as the image is aligned to the bottom left;
	} else {
		boxY = annotation.box_y / origImageHeight * 100;
		boxH = annotation.box_h / origImageHeight * 100;
		positionY = 'top';
	}
	
	annotationDiv.style.width = boxW + '%';
	annotationDiv.style.height = boxH + '%';
	annotationDiv.style.left = boxX + '%';
	
	if(positionY === 'top') {
		annotationDiv.style.top = boxY + '%';
	} else if(positionY === 'bottom') {
		annotationDiv.style.bottom = boxY + '%';
	}
}